
import Vue from 'vue'
import ImportPersonalAccount from '@/pages/app/wizard/ImportPersonalAccount.vue'

export default Vue.extend({
  name: 'ImportHouseWizard',
  components: {
    ImportPersonalAccount
  },
  data () {
    return {
    }
  },
  computed: {
    idSelectedOrganization (): number {
      return this.$store.state.profile.select_organization.id
    }
  }
})
